
import React from 'react';
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonHeader,
  IonRow,
} from '@ionic/react';
import { addLogNote } from '../utilities/ApiTasks';
import { getLog } from '../utilities/Updates';
import {cleanStoredArray } from '../utilities/Storage';
import {Toolbar} from "./Toolbar";
import {appBuild, appVersionLabel} from "../version";

export default function Help({ history }) {

  const sendDiagnostics = async () => {

    const log = await getLog();
    if(log.length > 0) {
      await addLogNote(log);
      await cleanStoredArray('log', 0);
      alert('done');
    } else {
      alert('nothing to send');
    }
    
  }

  return (
    <IonPage>
      <IonHeader>
        <Toolbar title="Help" backButtonHref="/" />
      </IonHeader>
      <IonContent>
        <IonGrid>
          <IonRow>
            <IonCol>
              <p>Version: v{appVersionLabel}.{appBuild} </p>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonButton expand="block" color="medium" onClick={sendDiagnostics}>send diagnostics</IonButton>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <IonButton expand="block" onClick={() => history.replace("/jobs")}>return to jobs</IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );  

}